import React from 'react';
import PropTypes from 'prop-types';
import Spin from 'antd/lib/spin';
//import PendingActionAlert from '../../../features/dashboard/components/PendingActionAlert';
import LoanItem from './LoanItem';
import SignLoan from './SignLoan';
import CardPaymentResult from '../../dashboard/components/CardPaymentResult';
// import SignLoanInsurance from './SignLoanInsurance';

const LoanList = ({
  items,
  showSignLoanModal,
  showConfirmLoanModal,
  showSignLoanInsuranceModal,
  showConfirmLoanInsuranceModal,
  isFetching,
  pendingActions,
  role,
  cardPaymentSuccess
}) => {

  return (
    <Spin spinning={isFetching}>
      {/* <PendingActionAlert pendingActions={pendingActions} /> */}
      <CardPaymentResult result={cardPaymentSuccess} />
      <section className="loans-wrapper list-wrapper">
        <SignLoan />

        {/* <SignLoanInsurance /> */}

        {items && items.length > 0 && items.map(loan => (
          <LoanItem
            loansNumber={items.length}
            loan={loan}
            key={loan.id}
            showSignLoanModal={showSignLoanModal}
            showConfirmLoanModal={showConfirmLoanModal}
            showSignLoanInsuranceModal={showSignLoanInsuranceModal}
            showConfirmLoanInsuranceModal={showConfirmLoanInsuranceModal}
            role={role}
          />
        ))}

      </section>
    </Spin>
  );

}

LoanList.propTypes = {
  items: PropTypes.array.isRequired,
  showSignLoanModal: PropTypes.func.isRequired,
  showConfirmLoanModal: PropTypes.func.isRequired,
  showSignLoanInsuranceModal: PropTypes.func.isRequired,
  showConfirmLoanInsuranceModal: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  pendingActions: PropTypes.number.isRequired,
};

export default LoanList;



// WEBPACK FOOTER //
// ./src/features/loans/components/LoanList.js